import React from "react";
import RedsysPayementFailed from "../Containers/Pages/Static/RedsysPayementFailed";
import RedsysMiddelRoute from "../Containers/Pages/Static/RedsysMiddelRoute";
import CustoMDesign from "../Containers/Pages/Static/CustoMDesign";
import CertifiedDiamonds from "../Containers/Pages/Static/custom-design/CertifiedDiamonds";
import JewelryInsurance from "../Containers/Pages/Static/custom-design/JewelryInsurance";
import EventsProposal from "../Containers/Pages/Static/custom-design/EventsProposal";
import PaymentPending from "../Components/aplazameStatic/PaymentPending";
import PaymentDismiss from "../Components/aplazameStatic/PaymentDismiss";
import PaymentError from "../Components/aplazameStatic/PaymentError";
import AplazameKo from "../Components/aplazameStatic/AplazameKo";
// import Bespoke from "../Containers/Pages/Static/Bespoke";
import Home from "../Containers/Front/showcase_2.o/Home";

const Myaccount = React.lazy(() => import("../Containers/Pages/Myaccount"));
const Register = React.lazy(() => import("../Containers/Pages/Register"));
const Productdetails = React.lazy(
  () => import("../Containers/Shopping/productDetails"),
);
const Bespoke = React.lazy(() => import("../Containers/Pages/Static/Bespoke"));
const Invoice = React.lazy(() => import("../Containers/Pages/invoice"));
const Cart = React.lazy(() => import("../Containers/Pages/cart"));
const Checkout = React.lazy(() => import("../Containers/Pages/checkout"));
const customDesigns = React.lazy(
  () => import("../Containers/Pages/Static/customDesigns"),
);
const Financing = React.lazy(
  () => import("../Containers/Pages/Static/financing"),
);
const MakeAnAppointment = React.lazy(
  () => import("../Containers/Pages/make-an-appointment"),
);
const Testimonials = React.lazy(
  () => import("../Containers/Pages/Static/testimonials"),
);
const Contact = React.lazy(() => import("../Containers/Pages/Static/contact"));
const ReturnsExchanges = React.lazy(
  () => import("../Containers/Pages/Static/returns-and-exchanges"),
);
const Cookies = React.lazy(() => import("../Containers/Pages/Static/Cookies"));

const PrivacyPolicy = React.lazy(
  () => import("../Containers/Pages/Static/privacy-policy"),
);
const TermsConditions = React.lazy(
  () => import("../Containers/Pages/Static/terms-and-conditions"),
);
const TermsAndConditionsRedsys = React.lazy(
  () => import("../Containers/Pages/Static/termsandconditions_redsys"),
);
const OurStory = React.lazy(
  () => import("../Containers/Pages/Static/our-story"),
);
const Blog = React.lazy(() => import("../Containers/Pages/Static/blog"));
const Ordersuccess = React.lazy(
  () => import("../Containers/Pages/Static/ordersuccess"),
);
const NoPage = React.lazy(() => import("../Containers/Pages/Static/NoPage"));
const Wishlist = React.lazy(() => import("../Containers/Pages/wishlist"));
const blogDetails = React.lazy(
  () => import("../Containers/Pages/Static/blogDetails"),
);
const pageDetails = React.lazy(
  () => import("../Containers/Pages/Static/pageDetails"),
);
const RingSettings = React.lazy(
  () => import("../Containers/Shopping/ringsettings"),
);
const RingSettingsDiamonds = React.lazy(
  () => import("../Containers/Shopping/ringsettings-diamonds"),
);
const RingSettingsDiamondsDetails = React.lazy(
  () => import("../Containers/Shopping/ringsettings-diamonds-details"),
);
const Gemstones = React.lazy(() => import("../Containers/Shopping/gemstone"));
const CompleteRing = React.lazy(
  () => import("../Containers/Shopping/complete-ring"),
);
const GemstonesDetails = React.lazy(
  () => import("../Containers/Shopping/gemstone-details"),
);
const FancyColorDiamond = React.lazy(
  () => import("../Containers/Shopping/FancyColorDiamond"),
);
const Fancycolordetail = React.lazy(
  () => import("../Containers/Shopping/fancy-detail"),
);
const FAQ = React.lazy(() => import("../Containers/Pages/Static/faq"));
const Productlist = React.lazy(
  () => import("../Containers/Shopping/productlist"),
);
const Home1 = React.lazy(() => import("../Containers/Front/showcase_2.o/Home"));
const Education = React.lazy(() => import("../Containers/Education/education"));
const GemstoneEducation = React.lazy(
  () => import("../Containers/Education/gemstone"),
);
const EngagementRingEducation = React.lazy(
  () => import("../Containers/Education/engagement-ring"),
);
const WeddingRingEducation = React.lazy(
  () => import("../Containers/Education/wedding-ring"),
);
const FineJewelryEducation = React.lazy(
  () => import("../Containers/Education/fine-jewelry"),
);
const LooseDiamondEducation = React.lazy(
  () => import("../Containers/Education/loose-diamonds"),
);
const Watches = React.lazy(() => import("../Containers/Shopping/Watches"));
const WatchDetails = React.lazy(
  () => import("../Containers/Shopping/WatchDetails"),
);
const StudSettings = React.lazy(
  () => import("../Containers/Shopping/Studbilder/stud-settings"),
);
const StudDiamonds = React.lazy(
  () => import("../Containers/Shopping/Studbilder/stud-diamonds"),
);
const Studdetails = React.lazy(
  () => import("../Containers/Shopping/Studbilder/Studdetails"),
);
const StudSettingDiamondsDetails = React.lazy(
  () => import("../Containers/Shopping/Studbilder/StudSettingDiamondDetails"),
);
const CompleteStud = React.lazy(
  () => import("../Containers/Shopping/Studbilder/complete-stud"),
);
const BandBuilder = React.lazy(
  () => import("../Containers/Shopping/BandBuilder"),
);

const Payment = React.lazy(() => import("../Containers/Pages/Static/Payment"));

export const routeConfig = [
  { en: "/", es: "/", component: Home },
  { en: "/bespoke", es: "/diseno-joyas-a-medida", component: Bespoke },
  { en: "/account/:value", es: "/cuenta/:value", component: Myaccount },
  { en: "/invoice/:order_id", es: "/factura/:order_id", component: Invoice },
  { en: "/register", es: "/register", component: Register },
  {
    en: "/engagement-rings",
    es: "/anillos-de-compromiso",
    component: RingSettings,
    exact: true,
  },
  {
    en: "/engagement-rings/:stone",
    es: "/engagement-rings/:stone",
    component: RingSettings,
    
    exact: true,
  },
  {
    en: "/ringsettingdetail/:id/:slug",
    es: "/ringsettingdetail/:id/:slug",
    component: Productdetails,
    exact: true,
  },
  {
    en: "/band-builder",
    es: "/band-builder",
    component: BandBuilder,
    exact: true,
  },
  { en: "/gemstones", es: "/gemstones", component: Gemstones, exact: true },
  {
    en: "/gemstones/:subcategory",
    es: "/gemstones/:subcategory",
    component: Gemstones,
    exact: true,
  },
  {
    en: "/fancy-color-diamond-animesh",
    es: "/fancy-color-diamond",
    component: FancyColorDiamond,
    exact: true,
  },
  {
    en: "/fancy-color-diamond-detail/:stock_no",
    es: "/fancy-color-diamond-detail/:stock_no",
    component: Fancycolordetail,
  },
   {
    en: "/wishlist",
    es: "/wishlist",
    component: Wishlist,
  },
  {
    en: "/diamonds",
    es: "/diamonds",
    component: RingSettingsDiamonds,
    exact: true,
  },
  {
    en: "/diamonds/lab/:subcategory",
    es: "/diamonds/lab/:subcategory",
    component: RingSettingsDiamonds,
    exact: true,
  },
  {
    en: "/diamonds/:subcategory",
    es: "/diamonds/:subcategory",
    component: RingSettingsDiamonds,
    exact: true,
  },
  { en: "/watches", es: "/watches", component: Watches, exact: true },
  {
    en: "/watches/:brand",
    es: "/watches/:brand",
    component: Watches,
    exact: true,
  },
  {
    en: "/diamonds-details/:stock_no",
    es: "/diamonds-details/:stock_no",
    component: RingSettingsDiamondsDetails,
  },
  {
    en: "/gemstone-details/:stock_no",
    es: "/gemstone-details/:stock_no",
    component: GemstonesDetails,
  },
  {
    en: "/watch-details/:stock_no",
    es: "/watch-details/:stock_no",
    component: WatchDetails,
  },
  {
    en: "/complete-diamond-ring",
    es: "/complete-diamond-ring",
    component: CompleteRing,
    exact: true,
  },
  {
    en: "/complete-gemstone-ring",
    es: "/complete-gemstone-ring",
    component: CompleteRing,
    exact: true,
  },
  {
    en: "/complete-fancycolor-ring",
    es: "/complete-fancycolor-ring",
    component: CompleteRing,
    exact: true,
  },
  {
    en: "/search/:search_text",
    es: "/buscar/:search_text",
    component: Productlist,
  },
  { en: "/cart", es: "/carrito", component: Cart, exact: true },
  {
    en: "/checkout-shipping",
    es: "/finalizar-compra-envio",
    component: Checkout,
    exact: true,
  },
  {
    en: "/custom-design",
    es: "/taller-artesania",
    component: CustoMDesign,
    exact: true,
  },
  {
    en: "/certified-diamonds",
    es: "/diamantes-certificados",
    component: CertifiedDiamonds,
    exact: true,
  },
  {
    en: "/jewelry-insurance",
    es: "/seguro-joyas",
    component: JewelryInsurance,
    exact: true,
  },
  {
    en: "/events-proposal",
    es: "/pedidas-de-mano",
    component: EventsProposal,
    exact: true,
  },
  { en: "/financing", es: "/financing", component: Financing, exact: true },
  {
    en: "/make-an-appointment",
    es: "/cita-previa",
    component: MakeAnAppointment,
    exact: true,
  },
  {
    en: "/testimonials",
    es: "/testimonials",
    component: Testimonials,
    exact: true,
  },
  {
    en: "/terms-and-conditions",
    es: "/terminos-condiciones",
    component: TermsConditions,
    exact: true,
  },
  {
    en: "/terms-conditions-redsys",
    es: "/terminos-condiciones-redsys",
    component: TermsAndConditionsRedsys,
    exact: true,
  },
  {
    en: "/privacy-policy",
    es: "/politica-privacidad",
    component: PrivacyPolicy,
    exact: true,
  },
  {
    en: "/returns-and-exchanges",
    es: "/cambios-y-devoluciones",
    component: ReturnsExchanges,
    exact: true,
  },
  { en: "/cookies", es: "/cookies", component: Cookies, exact: true },
  { en: "/payment", es: "/metodos-pago", component: Payment, exact: true },
  { en: "/contact", es: "/contacto", component: Contact, exact: true },
  { en: "/about", es: "/manuel-spinosa-historia", component: OurStory, exact: true },
  { en: "/blog", es: "/blog", component: Blog, exact: true },
  { en: "/faq", es: "/faq", component: FAQ, exact: true },
  {
    en: "/blog-details/:url",
    es: "/blog-details/:url",
    component: blogDetails,
  },
  {
    en: "/page-details/:url",
    es: "/page-details/:url",
    component: pageDetails,
  },
  {
    en: "/productdetail/:slug",
    es: "/productdetail/:slug",
    component: Productdetails,
    exact: true,
  },
  { en: "/success", es: "/pago-realizado", component: Ordersuccess, exact: true },
  {
    en: "/failure",
    es: "/pago-fallido",
    component: RedsysPayementFailed,
    exact: true,
  },
  {
    en: "/redsyspaymentproccess",
    es: "/redsyspaymentproccess",
    component: RedsysMiddelRoute,
    exact: true,
  },
  {
    en: "/payment_pending",
    es: "/payment_pending",
    component: PaymentPending,
    exact: true,
  },
  {
    en: "/payment_dismiss",
    es: "/payment_dismiss",
    component: PaymentDismiss,
    exact: true,
  },
  {
    en: "/payment_error",
    es: "/payment_error",
    component: PaymentError,
    exact: true,
  },
  {
    en: "/aplazame_ko",
    es: "/aplazame_ko",
    component: AplazameKo,
    exact: true,
  },
  {
    en: "/ordersuccess",
    es: "/ordersuccess",
    component: Ordersuccess,
    exact: true,
  },
  {
    en: "/fine-jewelry",
    es: "/joyeria-fina",
    component: Productlist,
    exact: true,
  },
  {
    en: "/wedding-rings",
    es: "/alianzas-de-boda",
    component: Productlist,
    exact: true,
  },
  {
    en: "/fine-jewelry/:subcategory",
    es: "/joyeria-fina/:subcategory",
    component: Productlist,
    exact: true,
  },
  {
    en: "/wedding-rings/:subcategory",
    es: "/alianzas-de-boda/:subcategory",
    component: Productlist,
    exact: true,
  },
  {
    en: "/education/gemstone-education",
    es: "/guia/piedras-preciosas",
    component: GemstoneEducation,
    exact: true,
  },
  {
    en: "/education/engagement-ring-education",
    es: "/guia/anillos-compromiso",
    component: EngagementRingEducation,
  },
  {
    en: "/education/wedding-ring-education",
    es: "/guia/alianzas-boda",
    component: WeddingRingEducation,
  },
  {
    en: "/education/fine-jewelry-education",
    es: "/education/fine-jewelry-education",
    component: FineJewelryEducation,
  },
  {
    en: "/education/loose-diamonds-education",
    es: "/guia/diamantes-sueltos",
    component: LooseDiamondEducation,
  },
  { en: "/education", es: "/guia-diamantes", component: Education, exact: true },
  {
    en: "/stud-settingdetail/:id/:slug",
    es: "/stud-settingdetail/:id/:slug",
    component: Studdetails,
  },
  {
    en: "/stud-diamonds-details/:pairId",
    es: "/stud-diamonds-details/:pairId",
    component: StudSettingDiamondsDetails,
  },
  {
    en: "/stud-settings",
    es: "/stud-settings",
    component: StudSettings,
    exact: true,
  },
  {
    en: "/stud-settings/:stone",
    es: "/stud-settings/:stone",
    component: StudSettings,
  },
  {
    en: "/stud-diamonds",
    es: "/stud-diamonds",
    component: StudDiamonds,
    exact: true,
  },
  {
    en: "/stud-diamonds/lab",
    es: "/stud-diamonds/lab",
    component: StudDiamonds,
    exact: true,
  },
  {
    en: "/complete-diamond-stud",
    es: "/complete-diamond-stud",
    component: CompleteStud,
  },
  { en: "*", es: "*", component: NoPage },

  
];
